module.exports = __webpack_public_path__ + "static/img/main.b9f9aef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/15/main.png
// module id = pP85
// module chunks = 1